import React from "react";

function FormCatScelte({
    variabili,
    scegliVariabile,
    nomeDisplay
}) {

    const proprietaDaIgnorare = ["id","friendlyName","nome","urlPiece","urlIntero","parametri"];

    const variabiliFiltrate = Object.keys(variabili).map((variabile) => {
        try {
            if (!proprietaDaIgnorare.includes(variabile)) {
                return {
                    nome: variabili[variabile].nome.it,
                    pezzoPath: variabile
                };
            } else {
                return false;
            }
        } catch (error) {
            console.log(variabile);
            console.log(error);
        }
        
    }).filter(Boolean); // Rimuove i "false" dall'array
    

    /* return <pre>{JSON.stringify(variabiliFiltrate,null,2)}</pre> */

    if (variabiliFiltrate.length > 0) {
        return <div className="b f5">
        {variabiliFiltrate.map((variabile, i) => <div key={i} onClick={(e)=>scegliVariabile(e,variabile.pezzoPath)} className="f5 pb3 pointer">{variabile.nome}</div>) }
        </div>
    } else {
        return <div className="f5 b">{nomeDisplay}</div>
    }

    
    
}

export default FormCatScelte;